import React from "react";
import { Classes as BpClasses } from "@blueprintjs/core";
import { useFormikContext } from "formik";
import { IMarkdownPartProps } from "../../models";
import { getAlignmentClass } from "../../models/utils";
import classnames from "classnames";
import css from "../../form.module.scss";
import { markdownToHtml } from "../../../../../utils/markdownUtils";
import { IPrefillData } from '../../../../../stores/formsStore';


// const markdownOptions: showdown.ShowdownOptions = {
//   noHeaderId: true,
//   strikethrough: true,
//   tables: true,
//   emoji: true,
//   parseImgDimensions: true
// };


// const stylingWhitelist = ["style", "class"];
// const xssOptions: xss.IFilterXSSOptions = {
//   whiteList: {
//     ...xss.getDefaultWhiteList(),
//     span: stylingWhitelist,
//     div: stylingWhitelist
//   }
// };


// export function useMarkdownContent(content: string | string[]) {
//   if (typeof content === 'string') {
//     content = [content];
//   }

//   const markdown = content.join('\n');
//   const { values } = useFormikContext<IPrefillData>();
//   const mergedContent = formatString(markdown, values);

//   const converter = new showdown.Converter(markdownOptions);
//   const unsafeHtml = converter.makeHtml(mergedContent);
//   const saferHtml = xss.filterXSS(unsafeHtml, xssOptions);
//   return saferHtml;
// }

type IProps = IMarkdownPartProps;

const MarkdownPart = (props : IProps) => {
  const alignmentClass = getAlignmentClass(props.alignment);
  const className = classnames(css.formPart, alignmentClass, BpClasses.RUNNING_TEXT);
  const { values } = useFormikContext<IPrefillData>();
  const __html = markdownToHtml(props.content, values);

  return (
    <div style={props.style} className={className}>
      <div dangerouslySetInnerHTML={{__html}} />
    </div>);

  // const markdown = (props.content || []).join('\n');
  // const converter = new showdown.Converter(markdownOptions);

  // return (
  //   <MergedContent content={markdown}>
  //     {(content) => {
  //       const unsafeHtml = converter.makeHtml(content);
  //       const saferHtml = xss.filterXSS(unsafeHtml, xssOptions);
  //       return (
  //         <div style={props.style} className={className}>
  //           <div dangerouslySetInnerHTML={{__html: saferHtml}} />
  //         </div>);
  //     }}
  //   </MergedContent>);
}

//const FormikMarkdownPart = formikConnect<IMarkdownPartProps>(MarkdownPart);
//export default FormikMarkdownPart;
export default MarkdownPart;








